import { Div } from '@moniebook-web/components/atoms/animation';
import { Body } from '@moniebook-web/components/atoms/typography';

import type { BusinessListProps } from '../../types';
import { BusinessItem } from '../business-item';

export function BusinessList({
    businesses,
    onSelectCurrentBusiness,
    search,
}: Readonly<BusinessListProps>) {
    if (search && businesses?.length === 0) {
        return (
            <Body className='italic! mb-24 text-center text-content-subtext-alternative'>
                No business found for your search. Try adjusting your keywords
            </Body>
        );
    }

    return (
        <Div className='flex max-h-280 flex-col gap-8 overflow-y-auto'>
            {businesses.map((business) => (
                <Div key={business.id}>
                    <BusinessItem
                        branchesCount={business.branchesCount}
                        isCurrent={business.isCurrent}
                        name={business.name}
                        onSelectCurrentBusiness={onSelectCurrentBusiness}
                        id={business.id}
                    />
                </Div>
            ))}
        </Div>
    );
}
